import { createIcon } from '@chakra-ui/react';

export const SsoIcon = createIcon({
  displayName: 'SsoIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '4',
    width: '4',
  },
  path: (
    <>
      <path
        d="M14 22V9M14 22H20C21.1046 22 22 21.1046 22 20V11C22 9.89543 21.1046 9 20 9H14M14 22H10M14 9V4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H6M6 22V19C6 17.8954 6.89543 17 8 17C9.10457 17 10 17.8954 10 19V22M6 22H10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6 13.5C6.27614 13.5 6.5 13.7239 6.5 14C6.5 14.2761 6.27614 14.5 6 14.5C5.72386 14.5 5.5 14.2761 5.5 14C5.5 13.7239 5.72386 13.5 6 13.5ZM10 13.5C10.2761 13.5 10.5 13.7239 10.5 14C10.5 14.2761 10.2761 14.5 10 14.5C9.72386 14.5 9.5 14.2761 9.5 14C9.5 13.7239 9.72386 13.5 10 13.5ZM6 9.5C6.27614 9.5 6.5 9.72386 6.5 10C6.5 10.2761 6.27614 10.5 6 10.5C5.72386 10.5 5.5 10.2761 5.5 10C5.5 9.72386 5.72386 9.5 6 9.5ZM10 9.5C10.2761 9.5 10.5 9.72386 10.5 10C10.5 10.2761 10.2761 10.5 10 10.5C9.72386 10.5 9.5 10.2761 9.5 10C9.5 9.72386 9.72386 9.5 10 9.5ZM6 5.5C6.27614 5.5 6.5 5.72386 6.5 6C6.5 6.27614 6.27614 6.5 6 6.5C5.72386 6.5 5.5 6.27614 5.5 6C5.5 5.72386 5.72386 5.5 6 5.5ZM10 5.5C10.2761 5.5 10.5 5.72386 10.5 6C10.5 6.27614 10.2761 6.5 10 6.5C9.72386 6.5 9.5 6.27614 9.5 6C9.5 5.72386 9.72386 5.5 10 5.5Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </>
  ),
});
